import { useTranslation } from 'react-i18next';
import { formatAmountInCurrency } from '../utils';
import { Box, Typography, Input } from '@mui/material';

type PointDisplayProps = {
  title: string;
  imageUrl: string;
  color: string;
  points: number;
  fiat: number;
  currency: string;
  currencyExchangeRate?: number;
};

export const PointDisplay = (props: PointDisplayProps) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'start',
        gap: 3,
        flex: 1,
      }}
    >
      <Typography>{props.title}</Typography>
      <Typography color={props.color}>
        {props.points > 0
          ? t('pointDisplay.points', { points: props.points.toFixed(2) })
          : '-'}
      </Typography>
      <Box sx={{ display: 'flex', width: 45, height: 45 }}>
        <img src={props.imageUrl} />
      </Box>
      {props.currencyExchangeRate && (
        <Typography>
          {formatAmountInCurrency(
            props.fiat / props.currencyExchangeRate,
            'TRY',
          )}
        </Typography>
      )}
      <Typography variant="inherit">
        ({formatAmountInCurrency(props.fiat, props.currency)})
      </Typography>
    </Box>
  );
};
